// ══════════════════════════════════════════════════
// HEINENS PARTS — Shopify theme JS
// Cart operations use Shopify's real Cart AJAX API
// (/cart/add.js, /cart/change.js, /cart.js) — no more
// mock local data, this is genuinely live.
// ══════════════════════════════════════════════════

function money(cents) {
  return '$' + (cents / 100).toFixed(2);
}

// Escapes text before it reaches innerHTML. The cart JSON carries
// Parts Unlimited titles verbatim, and inch marks are common in them
// ("ROTOR 11.5\""), which used to break straight out of alt="..." and
// spill the rest of the title into the <img> tag as stray attributes.
function esc(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

function iconSvg(id) {
  return `<svg class="icon" style="width:52px;height:52px;color:var(--muted2)"><use href="#${id}"/></svg>`;
}

// ── CART SIDEBAR ────────────────────────────────────
function openCart() {
  document.getElementById('cartSidebar').classList.add('open');
  document.getElementById('cartOverlay').classList.add('open');
}
function closeCart() {
  document.getElementById('cartSidebar').classList.remove('open');
  document.getElementById('cartOverlay').classList.remove('open');
}

async function refreshCart() {
  /* Guarded because this is called unawaited on DOMContentLoaded: an
     unhandled rejection there left the drawer stuck on "Loading cart..."
     for the rest of the session with nothing to explain it. */
  try {
    const res = await fetch('/cart.js');
    if (!res.ok) throw new Error('cart.js ' + res.status);
    const cart = await res.json();
    renderCart(cart);
    return cart;
  } catch (err) {
    console.error('Could not read the cart:', err);
    return null;
  }
}

/* Shows a message inside the cart drawer rather than an alert(), so a
   failure lands where the shopper is already looking. */
function cartNotice(message) {
  const body = document.getElementById('cartBody');
  if (!body) { alert(message); return; }
  let el = document.getElementById('cartNotice');
  if (!el) {
    el = document.createElement('div');
    el.id = 'cartNotice';
    el.style.cssText = 'margin:12px;padding:10px 12px;border:1px solid var(--red);' +
      'background:#fff5f5;color:var(--red);font-size:13px;font-weight:600;';
    body.insertAdjacentElement('beforebegin', el);
  }
  el.textContent = message;
}

function clearCartNotice() {
  const el = document.getElementById('cartNotice');
  if (el) el.remove();
}

function renderCart(cart) {
  document.getElementById('cartBadge').textContent = cart.item_count;

  const body = document.getElementById('cartBody');
  const foot = document.getElementById('cartFoot');

  if (cart.item_count === 0) {
    body.innerHTML = `<div class="cart-empty-state">${iconSvg('i-cart')}<p style="font-weight:600;">Your cart is empty</p><p style="font-size:13px;margin-top:4px;color:var(--muted2);">Add parts to get started</p></div>`;
    foot.style.display = 'none';
    return;
  }

  foot.style.display = 'block';
  document.getElementById('cartSubtotal').textContent = money(cart.total_price);
  document.getElementById('cartTotal').textContent = money(cart.total_price);

  body.innerHTML = cart.items.map(item => `
    <div class="cart-item">
      <div class="ci-img">${item.image ? `<img src="${esc(item.image)}" alt="${esc(item.product_title)}" style="width:100%;height:100%;object-fit:contain;">` : iconSvg('i-package')}</div>
      <div class="ci-info">
        <div class="ci-brand">${esc(item.vendor || '')}</div>
        <div class="ci-name">${esc(item.product_title)}</div>
        <div class="ci-price-row">
          <span class="ci-price">${money(item.final_line_price)}${item.quantity > 1 ? `<span style="font-weight:400;color:var(--muted);font-size:11px;"> (${money(item.final_price)} ea)</span>` : ''}</span>
          <div class="ci-qty">
            <button onclick="changeCartQty(${item.key ? `'${item.key}'` : item.variant_id}, ${item.quantity - 1})">−</button>
            <span>${item.quantity}</span>
            <button onclick="changeCartQty(${item.key ? `'${item.key}'` : item.variant_id}, ${item.quantity + 1})">+</button>
          </div>
        </div>
      </div>
      <button class="ci-remove" onclick="changeCartQty(${item.key ? `'${item.key}'` : item.variant_id}, 0)">✕</button>
    </div>`).join('');
}

/* One add at a time. Without this, two taps inside the request window
   sent two POSTs and the line landed at quantity 2 -- and because the
   drawer only opens once the first request resolves, there was no
   feedback telling the shopper to stop tapping, which is exactly what
   provoked the second tap. */
let addInFlight = false;

async function addToCart(variantId, quantity = 1, btn = null) {
  if (addInFlight) return;
  addInFlight = true;
  const restore = btn ? btn.textContent : null;
  if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
    });
    /* fetch only rejects on a network-level failure -- it resolves
       normally on 4xx/5xx. /cart/add.js returns 422 when the variant is
       sold out, has been deactivated, or the quantity exceeds available
       inventory. Without this check the drawer opened on a cart that did
       NOT contain the item, with nothing on screen to explain it, which
       on a live-inventory drop-ship catalog happens routinely. */
    if (!res.ok) {
      let message = 'Sorry, that item could not be added to your cart.';
      try {
        const body = await res.json();
        if (body && body.description) message = body.description;
        else if (body && body.message) message = body.message;
      } catch (e) { /* non-JSON error body; keep the generic message */ }
      await refreshCart();
      openCart();
      cartNotice(message);
      return;
    }
    clearCartNotice();
    await refreshCart();
    openCart();
  } catch (err) {
    console.error('Add to cart failed:', err);
    openCart();
    cartNotice('We could not reach the cart. Please check your connection and try again.');
  } finally {
    addInFlight = false;
    if (btn) { btn.disabled = false; if (restore !== null) btn.textContent = restore; }
  }
}

async function changeCartQty(idOrKey, quantity) {
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: idOrKey, quantity }),
    });
    if (!res.ok) {
      /* 422 here means the requested quantity exceeds what's available.
         Previously the number simply snapped back with no explanation,
         so the +/- buttons read as broken. */
      let message = 'We could not update that quantity.';
      try {
        const body = await res.json();
        if (body && body.description) message = body.description;
        else if (body && body.message) message = body.message;
      } catch (e) {}
      await refreshCart();
      cartNotice(message);
      return;
    }
    clearCartNotice();
    await refreshCart();
  } catch (err) {
    console.error('Cart update failed:', err);
    cartNotice('We could not reach the cart. Please try again.');
  }
}

// ── EVENT WIRING ─────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  refreshCart();

  document.getElementById('cartToggle')?.addEventListener('click', (e) => {
    e.preventDefault();
    openCart();
  });
  document.getElementById('cartClose')?.addEventListener('click', closeCart);
  document.getElementById('cartOverlay')?.addEventListener('click', closeCart);

  // Event delegation for every "Add to Cart" button on product/collection pages
  document.body.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    addToCart(variantId, 1, btn);
  });

  // Product page variant selector → swap price/availability without reload
  document.querySelectorAll('[data-variant-select]').forEach(select => {
    select.addEventListener('change', function () {
      const selected = this.selectedOptions[0];
      if (!selected) return;

      /* Price, part number and compare-at update whether or not an Add
         to Cart button exists. They used to sit INSIDE an `if (btn &&
         selected)`, so on a phone-order-only product -- which renders
         the variant dropdown but no Add to Cart button at all -- the
         big price never changed when the shopper picked a different
         size. They would then ring up quoting the wrong price, on
         exactly the product class where phoning in IS the sale path. */
      const priceEl = document.getElementById('productPrice');
      if (priceEl && selected.dataset.price) priceEl.textContent = selected.dataset.price;

      /* The part number is the field a parts customer reads back over
         the phone. It had no hook at all, so it kept showing the first
         variant's SKU beside another variant's price. */
      const skuEl = document.getElementById('productSku');
      if (skuEl) {
        if (selected.dataset.sku) {
          skuEl.textContent = selected.dataset.sku;
          skuEl.parentElement.style.display = '';
        } else {
          skuEl.parentElement.style.display = 'none';
        }
      }

      const compareEl = document.getElementById('productCompare');
      if (compareEl) {
        if (selected.dataset.compare) {
          compareEl.textContent = selected.dataset.compare;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      /* Keep the URL in step so refresh, Back and a shared link all
         land on the variant the shopper is actually looking at. */
      if (selected.value && window.history && history.replaceState) {
        const u = new URL(window.location.href);
        u.searchParams.set('variant', selected.value);
        history.replaceState({}, '', u.toString());
      }

      /* `[data-add-to-cart]` is scoped to the buy box rather than the
         whole document, so a related-products grid added above it can't
         silently capture this handler. */
      const buyBox = this.closest('.pdp-layout') || document;
      const btn = buyBox.querySelector('[data-add-to-cart]');
      if (btn) {
        btn.setAttribute('data-variant-id', selected.value);
        const available = selected.getAttribute('data-available') === 'true';
        /* Button text comes from the theme settings, surfaced on
           window.THEME_TEXT by layout/theme.liquid. It used to be
           hardcoded here, so changing it in the theme editor worked
           until a shopper picked a variant, then silently reverted. */
        const txt = (window.THEME_TEXT || {});
        btn.textContent = available
          ? (txt.addToCart || '+ Add to Cart')
          : (txt.soldOut || 'Sold Out');
        btn.disabled = !available;
      }
    });
  });
});
